module.exports = __webpack_public_path__ + "media/images/global/projects/collaboration-ca115e1dd29794d4a525eed1c8af2998.png";